import { DateTime } from "luxon";
import { useState } from "react";
import { EventDisplayData } from "../../../../../../common/sesh_types";
import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { useServerId } from "../hooks/use_server_id";
import { EventTemplateList as EventTemplatePrevEventInfiniteList } from "./event_template_list";
import { EventTemplateModalRow } from "./event_template_modal_row";
import { TemplateSelection } from "./event_template_page";
import { EventTemplateSaveFavoriteInput } from "./event_template_save_favorite_input";

export function EventTemplatePrevEventList(props: {
	setSelectedTemplate: (template: TemplateSelection) => void;
	setSelectedInfoTemplate: (template: TemplateSelection) => void;
	onUseClick: (template: TemplateSelection) => void;
	selected_template: TemplateSelection | null;
	are_bookmarks_full?: boolean;
	search: string;
}) {
	const server_id = useServerId();

	const context = trpc.useContext();

	const [favoriting_event, setFavoritingEvent] = useState(
		null as null | EventDisplayData
	);
	const [favoriting_event_name, setFavoritingEventName] = useState("");

	// Have to cast this to any because useInfiniteQuery only appears if we have strict mode enabled
	const event_list_query = (trpc.event.list as any).useInfiniteQuery(
		{
			guild_id: server_id,
			include_completed: true,
			search: props.search,
			cursor: 0,
			sort: {
				type: "Created",
				direction: "DESC",
			},
		},
		{
			getNextPageParam: (lastPage) => lastPage.next_page,
			refetchOnWindowFocus: false,
			cacheTime: Infinity,
		}
	);

	return (
		<>
			<EventTemplatePrevEventInfiniteList
				list_query={event_list_query}
				itemCreator={(item) => {
					const existing_bookmark =
						context.event_template.getBookmarkedList
							.getData({
								guild_id: server_id,
							})
							?.find(
								(val) =>
									val.json.event_message_id ===
										item.message_id &&
									val.event_edit_version === item.edit_version
							);

					return (
						<EventTemplateModalRow
							are_bookmarks_full={props.are_bookmarks_full}
							item_id={item.message_id}
							bookmark_id={existing_bookmark?.id}
							item_name={item.name}
							author_id={item.author_id}
							created_at={DateTime.fromJSDate(
								new Date(item.created_at_str)
							)}
							selected_template={props.selected_template}
							onFavoriteClicked={() => {
								setFavoritingEvent(item);
								setFavoritingEventName(item.name);
								// mutation.mutate({
								// 	message_id: item.message_id,
								// });
							}}
							onUseClick={() =>
								props.onUseClick({
									message_id: item.message_id,
									name: item.name,
								})
							}
							onRowClick={() =>
								props.setSelectedTemplate({
									message_id: item.message_id,
									name: item.name,
								})
							}
							onInfoClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								props.setSelectedInfoTemplate({
									message_id: item.message_id,
									name: item.name,
								});
							}}
							info_text={
								existing_bookmark ? (
									<span className="flex gap-2">
										<span className="">
											<i
												className="fas fa-star"
												key="star"
											></i>{" "}
											<span className="">
												Favorited as{" "}
												<span className="font-semibold">
													{existing_bookmark.name}
												</span>
											</span>
										</span>
									</span>
								) : undefined
							}
							is_event_list={true}
						/>
					);
				}}
			/>
			{favoriting_event && (
				<DashboardUtils.SeshModal
					title={"Favoriting Template"}
					subtitle={
						"Template will be accessible to everyone in the server"
					}
					is_active={true}
					content={
						<div className="flex flex-col gap-4">
							<EventTemplateSaveFavoriteInput
								is_full={props.are_bookmarks_full}
								initial_name={favoriting_event.name}
								save_props={{
									message_id: favoriting_event.message_id,
								}}
								onSaveSuccess={() => setFavoritingEvent(null)}
								label={"Favorite"}
							/>
						</div>
					}
					onClose={() => setFavoritingEvent(null)}
				></DashboardUtils.SeshModal>
			)}
		</>
	);
}
